import { call, take, put } from 'redux-saga/effects';
import { get, post } from '../../utils/api';
import settings from '../../utils/settings';
import {
  GET_DEVICE_TYPES_REQUEST,
  GET_DEVICE_TYPES_SUCCESS,
  GET_DEVICE_TYPES_FAILURE,
  GET_DEVICE_TYPES_TIMEOUT,

GET_REPLACEMENT_BY_DEVICE_TYPE_REQUEST,
GET_REPLACEMENT_BY_DEVICE_TYPE_SUCCESS,
GET_REPLACEMENT_BY_DEVICE_TYPE_FAILURE,
GET_REPLACEMENT_BY_DEVICE_TYPE_TIMEOUT,

POST_CONFIRM_REPLACEMENT_REQUEST,
POST_CONFIRM_REPLACEMENT_SUCCESS,
POST_CONFIRM_REPLACEMENT_FAILURE,
POST_CONFIRM_REPLACEMENT_TIMEOUT,


GET_RMA_STATUS_REQUEST,
GET_RMA_STATUS_SUCCESS,
GET_RMA_STATUS_FAILURE,
GET_RMA_STATUS_TIMEOUT
} from './constants';


export function* getDeviceTypes() {
  while (true) {
    const request = yield take(GET_DEVICE_TYPES_REQUEST);
    const {
      siteId,
      replacementType
    } = request.payload;
    try {
      const response = yield call(get, {
          url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/${siteId}/replacement_devices_info?type=${replacementType}`),
          credentials:'include'
        });
      const { success, result,XSRFTOKEN } = response;
      if (success) {
        const {data,hems_status_code=null} = result;
        yield put({
          type: GET_DEVICE_TYPES_SUCCESS,
          payload: {data,hems_status_code,XSRFTOKEN}
        });
      } else {
        yield put({ type: GET_DEVICE_TYPES_FAILURE, payload:result?.error?.status || "Please try later." });
      }
    } catch (error) {
      yield put({ type: GET_DEVICE_TYPES_FAILURE, payload: "Please try later." });
    }
  }
}


export function* getReplacementByDeviceType() {
  while (true) {
    const request = yield take(GET_REPLACEMENT_BY_DEVICE_TYPE_REQUEST);
    const {
      siteId,
      deviceType
    } = request.payload;
    try {
      const response = yield call(get, {
          url: settings.getHEMSIntegrationApiUrl(`api/v1/hems/${siteId}/hems-devices/rma-device?device-type=${deviceType}`),
          credentials:'include'
        });
      const { success, result } = response;
      if (success) {
        const data = result.data;
        yield put({
          type: GET_REPLACEMENT_BY_DEVICE_TYPE_SUCCESS,
          payload: data
        });
      } else {
        yield put({ type: GET_REPLACEMENT_BY_DEVICE_TYPE_FAILURE, payload:result?.error?.status || "Please try later." });
      }
    } catch (error) {
      yield put({ type: GET_REPLACEMENT_BY_DEVICE_TYPE_FAILURE, payload: "Please try later." });
    }
  }
}

export function* confirmDeviceReplacement() {
  while (true) {
    const request = yield take(POST_CONFIRM_REPLACEMENT_REQUEST);
    try {
      const {siteId,deviceType,oldDeviceUID,newDeviceUID,XSRFTOKEN} = request.payload;
      let response;
      response = yield call(post, {
        url: settings.getHEMSIntegrationApiUrl(`api/v1/hems/${siteId}/hems-devices/rma-device`),
        body:{"device-type":deviceType,"old-device-uid":oldDeviceUID,"new-device-uid":newDeviceUID},
        credentials:'include',
        XSRFTOKEN
      });
      const { success, result } = response;
      if (success) {
        const data = result.data;
        yield put({ type: POST_CONFIRM_REPLACEMENT_SUCCESS, payload: data });
      } else {
        yield put({ type: POST_CONFIRM_REPLACEMENT_FAILURE, payload:result?.error?.status || "Please try later."  });
      }
    } catch (error) {
      yield put({ type: POST_CONFIRM_REPLACEMENT_FAILURE, payload:"Please try later."  });
    }
  }
}


export function* getRMAStatus() {
  while (true) {
    const request = yield take(GET_RMA_STATUS_REQUEST);
    const {
      siteId,
      RMAid
    } = request.payload;
    try {
      const response = yield call(get, {
          url: settings.getHEMSIntegrationApiUrl(`api/v1/hems/${siteId}/hems-devices/rma-device/${RMAid}`),
          credentials:'include'
        });
      const { success, result } = response;
      if (success) {
        const data = result.data;
        yield put({
          type: GET_RMA_STATUS_SUCCESS,
          payload: data
        });
      } else {
        yield put({ type: GET_RMA_STATUS_FAILURE, payload:result?.error?.status || "Please try later." });
      }
    } catch (error) {
      yield put({ type: GET_RMA_STATUS_FAILURE, payload: "Please try later." });
    }
  }
}